module.exports = __webpack_public_path__ + "static/doctorwoo-8842d3a20055d653f1d75b7204dabf2b.jpg";